import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { Texture } from './Texture.js';
import { CubeReflectionMapping, RGBFormat } from '../constants.js';

var CubeTexture = /*#__PURE__*/function (_Texture) {
  _inheritsLoose(CubeTexture, _Texture);

  function CubeTexture(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding) {
    var _this;

    images = images !== undefined ? images : [];
    mapping = mapping !== undefined ? mapping : CubeReflectionMapping;
    format = format !== undefined ? format : RGBFormat;
    _this = _Texture.call(this, images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding) || this;
    _this.flipY = false;
    return _this;
  }

  _createClass(CubeTexture, [{
    key: "images",
    get: function get() {
      return this.image;
    },
    set: function set(value) {
      this.image = value;
    }
  }]);

  return CubeTexture;
}(Texture);

CubeTexture.prototype.isCubeTexture = true;
export { CubeTexture };